module.exports = __webpack_public_path__ + "images/create-first-board/card-back/cardBack-hu.d986f0bc15943e21f060.svg";